import { cn } from "@/lib/utils";
import { ReactNode } from "react";

/**
 * One keycap in a keyboard shortcut, e.g. <Kbd>Shift</Kbd> <Kbd>7</Kbd>.
 * Sits at the quiet end of the type scale — a shortcut is a hint, never the
 * thing being read.
 */
export const Kbd = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <kbd
    className={cn(
      "inline-flex h-5 min-w-5 items-center justify-center rounded-[5px] px-1.5",
      // Darker than any surface it sits on, so a keycap reads as a key rather
      // than as a chip tinted the same as its container.
      "border border-neutral-700 bg-neutral-900",
      "font-sans text-[11px] leading-none text-neutral-300",
      className,
    )}
  >
    {children}
  </kbd>
);
